import React from 'react'
import { Button, ButtonProps } from 'reactstrap'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import colors from 'constants/colors'
import { Link } from 'react-router-dom'

const StyledButton = styled(Button)`
    color: ${colors.black};
    background-color: white;
    border-color: ${colors.secondaryBorder};
    font-family: Poppins;
    font-weight: 500;
    font-size: 14px;
    letter-spacing: 0;
    padding: 7px 15px;
    border-radius: 7px;

    &:hover {
      background-color: ${colors.secondaryHover};
      border-color: ${colors.secondaryBorder};
      color: ${colors.black};
    }
    &:focus {
      background-color: ${colors.secondaryHover};
      border-color: ${colors.secondaryBorder};
      color: ${colors.black};
    }
    &:active {
      background-color: ${colors.secondaryHover} !important;
      border-color: ${colors.secondaryBorder} !important;
      color: ${colors.black} !important;
    }
`

const StyledIcon = styled(FontAwesomeIcon)`
    margin-right: 7px;
`

interface SecondaryButtonProps {
  title?: string,
  icon?: any,
  buttonProps?: ButtonProps,
  onClick?: () => void,
  to?: string
}

const SecondaryButton:React.FC<SecondaryButtonProps> = (
  {
    title,
    icon,
    buttonProps,
    onClick,
    to,
  },
) => {
  // if link is passed in use a react-router Link element instead
  // of the default button
  let tag: String | React.ReactType = 'button'
  if (to) {
    tag = Link
  }

  return (
    <StyledButton color="secondary" to={to} tag={tag} onClick={onClick} {...buttonProps}>
      {icon && <StyledIcon icon={icon} />}
      {' '}
      {title}
    </StyledButton>
  )
}

export default SecondaryButton
